import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  getOrderStatistics() {
    return this.provider.getOrderStatistics();
  }

  sendEmail(params: ProviderIos.SendEmail.In) {
    return this.provider.sendEmail(params);
  }

  getRevenueForYear(params: ProviderIos.GetRevenueForYear.In) {
    return this.provider.getRevenueForYear(params);
  }

  getCreationDateOfFirstOrder() {
    return this.provider.getCreationDateOfFirstOrder();
  }
}

export { Service };
